<template>
    <div class="msg-modal success">
        <div class="img">
            <img :src="require(`@/assets/checkmark-circle.svg`)" alt="checkmark-circle.svg" />
        </div>

        <div class="message">{{ message }}</div>
    </div>
</template>

<script>
export default {
    name: 'SuccessMsgModal',
    data() {
        return {
            message: ''
        }
    },
    props: {
        msg: {
            type: String,
            default: ''
        }
    },
    mounted() {
        this.message = this.msg
    }
}
</script>



// WEBPACK FOOTER //
// src/ui/modal/success-msg-modal/SuccessMsgModal.vue